<script setup lang="ts">
import Modal from './Modal.vue';
import useModal, { ModalTypes } from '../composables/useModal';
import { useLocale } from '../composables/useLocale';

const { t } = useLocale();

const props = defineProps<{
  name: ModalTypes;
}>();
const emits = defineEmits(['confirm', 'cancel']);

const { close } = useModal(props.name);

const { isOpen } = useModal(props.name);
const onCancel = () => {
  emits('cancel');
  close();
};
</script>

<template>
  <Modal
    :name="name"
    :title="t('lcp.unsaved_changes')"
    :is-open="isOpen"
    :action="
      () => {
        emits('confirm');
        close();
      }
    "
    :action-label="t('lcp.leave_without_saving')"
    :cancel-action-label="t('lcp.back')"
    :cancel-action="onCancel"
    @close="onCancel"
  >
    <p>
      {{ t('lcp.unsaved_changes_message') }}
    </p>
  </Modal>
</template>
